export default "__VITE_ASSET__JBjcV157__"